import { create } from "zustand";

interface Message {
  role: "user" | "assistant";
  content: string;
  id?: string;
  created_at?: string;
  metadata?: Record<string, any> | null;
}

interface Conversation {
  id: string;
  user_id: string;
  title: string;
  updated_at: string;
  deleted_at: string | null;
  template?: string;
}

interface ChatStore {
  activeConversationId: string | null;
  messages: Message[];
  isStreaming: boolean;
  conversations: Conversation[];
  pendingInitialMessage: string | null;
  setActiveConversation: (id: string) => void;
  addMessage: (msg: Message, updateLast?: boolean) => void;
  setStreaming: (streaming: boolean) => void;
  clearMessages: () => void;
  setMessages: (msgs: Message[]) => void;
  setConversations: (conversations: Conversation[] | ((prev: Conversation[]) => Conversation[])) => void;
  setPendingInitialMessage: (msg: string | null) => void;
}

export const useChatStore = create<ChatStore>((set) => ({
  activeConversationId: null,
  messages: [],
  isStreaming: false,
  conversations: [],
  pendingInitialMessage: null,

  setActiveConversation: (id) =>
    set({ activeConversationId: id, messages: [] }),

  addMessage: (msg, updateLast = false) =>
    set((state) => {
      if (updateLast && state.messages.length > 0) {
        // ✅ CORREÇÃO 2: Só substitui se a última for da IA
        const updated = [...state.messages];
        const last = updated[updated.length - 1];
        if (last?.role === "assistant") {
          updated[updated.length - 1] = msg;
          return { messages: updated };
        }
        return { messages: [...state.messages, msg] };
      }
      return { messages: [...state.messages, msg] };
    }),

  setStreaming: (streaming) => set({ isStreaming: streaming }),

  clearMessages: () => set({ messages: [] }),

  // ✅ CORREÇÃO 2: Adiciona setMessages para carregar histórico
  setMessages: (msgs) => set({ messages: msgs }),

  // ✅ Atualizar lista de conversas (estado local)
  setConversations: (conversationsOrFn) =>
    set((state) => ({
      conversations: typeof conversationsOrFn === 'function'
        ? conversationsOrFn(state.conversations)
        : conversationsOrFn
    })),

  setPendingInitialMessage: (msg) => set({ pendingInitialMessage: msg }),
}));
